import { MessageCircle, Phone } from 'lucide-react';

function toWaNum(phone) {
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length === 9) return `221${digits}`;
  if (digits.length === 14 && digits.startsWith('00221')) return digits.slice(2);
  return digits;
}

/**
 * Boutons Appeler + WhatsApp côte à côte.
 * Utilisé dans toutes les vues de détail de commande.
 *
 * `onCall` (optionnel) est appelé à chaque appui sur Appeler, sans bloquer
 * l'ouverture du composeur — c'est ce qui alimente l'historique des appels.
 */
export default function OrderContactButtons({ phone, style = {}, onCall = null }) {
  if (!phone) return null;
  const waNum = toWaNum(phone);
  return (
    <div style={{ display: 'flex', gap: '10px', ...style }}>
      <a
        href={`tel:${phone}`}
        onClick={onCall ? () => onCall() : undefined}
        style={{
          flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
          padding: '13px', borderRadius: '12px',
          background: 'linear-gradient(135deg, #173b78, #2a66b8)',
          color: 'white', fontSize: '14px', fontWeight: 700,
          textDecoration: 'none', boxShadow: '0 4px 12px rgba(23,59,120,0.3)',
        }}
      >
        <Phone size={16} /> Appeler
      </a>
      <a
        href={`https://wa.me/${waNum}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
          padding: '13px', borderRadius: '12px',
          background: 'linear-gradient(135deg, #16a34a, #15803d)',
          color: 'white', fontSize: '14px', fontWeight: 700,
          textDecoration: 'none', boxShadow: '0 4px 12px rgba(22,163,74,0.3)',
        }}
      >
        <MessageCircle size={16} /> WhatsApp
      </a>
    </div>
  );
}
